export default async function CreatePlanAttributeApi(
    name,
    valueType
  ) {
    let res = "";
    try {
      const body = {
        name: name,
        valueType: valueType
      };
      const token = "Bearer " + localStorage.getItem("authToken");
      const requestOptions = {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          accept: "application/json",
          Authorization: token,
        },
        body: JSON.stringify(body),
      };
      await fetch(
        `${process.env.REACT_APP_API_URL}v1/plan-attributes/custom-attribute`,
        requestOptions
      )
        .then((response) => response.json())
        .then((response) => {
          res = response;
        })
        .catch((error) => {
          console.error("Error create custom attribute: ", error);
          res = error;
        });
    } catch (error) {
      console.error(error);
      res = error;
    }
  
    return res;
  }
  